// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-jhs-free-graduation-btn-float-bottom-btn[data-v-962457d4]{display:block}.c-jhs-free-graduation-btn-float-bottom-btn img[data-v-962457d4]{height:100%}.c-jhs-free-graduation-btn-float-bottom[data-v-962457d4] .c-float-bottom-background{border-top:none;background:rgba(0,0,0,0);margin:0 -2.1333333333%;padding:0}", ""]);
// Exports
module.exports = exports;
